const subnav = document.querySelector('[data-behaviour="subnav"]');
import { throttle } from './utilities.js';

if ( subnav ) {
    
    const dropdown = subnav.querySelector('[data-action="dropdown"]');
    const current = subnav.querySelector('[data-target="current"]');
    const sections = [...document.querySelectorAll('[data-behaviour="sticky-section"]')];

    dropdown.addEventListener('click', (ev) => {
        ev.preventDefault();

        if( subnav.dataset.open == 'true' ) {
            subnav.setAttribute('data-open', 'false');
        } else {
            subnav.setAttribute('data-open', 'true');
        }

    });

    document.addEventListener('jumpLinkEvent', (event) => {
        subnav.setAttribute('data-open', 'false');
    });
    
    window.addEventListener('scroll', throttle(navHighlighter, 200));

    window.addEventListener('scrollend', navHighlighter);

    navHighlighter();
    
    function navHighlighter() {
        
        // Get current scroll position
        let scrollY = window.scrollY;
        
        // Now we loop through sections to get height, top and ID values for each
        sections.forEach(section => {

            const sectionHeight = section.offsetHeight;
            let sectionTop = section.getBoundingClientRect().top + document.documentElement.scrollTop - subnav.offsetHeight - 1;
            const sectionId = section.getAttribute("id");
            const navItem = subnav.querySelector(`[href="#${sectionId}"]`);

            
            /*
            - If our current scroll position enters the space where current section on screen is, add .active class to corresponding navigation link, else remove it
            - To know which link needs an active class, we use sectionId variable we are getting while looping through sections as an selector
            */
            if (
                scrollY > sectionTop &&
                scrollY <= sectionTop + sectionHeight
            ){
                const navLabel = navItem.dataset.name;
                current.innerHTML = navLabel;
                navItem.setAttribute('data-active', 'true');
            } else {
                navItem.setAttribute('data-active', 'false');
            }

        });

    }

}